import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class AdminAccessService {

  constructor(private _http_service: HttpService) {}

  isAdmin(): Observable<boolean> {
    return this._http_service.get('admin/auth/me').pipe(
      map((response) => response.code === 200),
      catchError(() => of(false))
    );
  }
}
